import { useEffect, useState } from "react";

import Skeleton from "@/components/shared/Skeleton";
import { FEEDBACK_STATUS_LABEL as STATUS_LABEL } from "@/config/dropdownData";
import { FeedbackService } from "@/services/feedbackService";
import { formatDate } from "@/utils/dateUtils";

/** Every status change, oldest first, with the reason given for one that ended it. */
const StatusHistory = ({ feedbackId, status }) => {
  const [state, setState] = useState({ rows: null, failed: false });

  useEffect(() => {
    let alive = true;
    setState({ rows: null, failed: false });
    FeedbackService.history(feedbackId)
      .then((res) => alive && setState({ rows: res?.data ?? [], failed: false }))
      .catch(() => alive && setState({ rows: null, failed: true }));
    return () => {
      alive = false;
    };
    // `status` refetches after a change, so the newest reason shows.
  }, [feedbackId, status]);

  if (state.failed) return <p className="text-xs text-text-secondary">Couldn't load the status history.</p>;
  if (!state.rows) return <Skeleton className="h-12 w-full rounded-lg" />;
  if (!state.rows.length) return <p className="text-xs text-text-secondary">No status changes yet.</p>;
  return (
    <ol className="space-y-3">
      {state.rows.map((change) => (
        <li key={`${change.created_at}-${change.to_status}`} className="border-l-2 border-border-primary pl-3">
          <p className="text-xs text-text-secondary">
            {STATUS_LABEL[change.from_status] ?? change.from_status} → {STATUS_LABEL[change.to_status] ?? change.to_status} · {formatDate(change.created_at)}
          </p>
          {change.reason && <p className="whitespace-pre-wrap break-words text-sm text-text-primary">{change.reason}</p>}
        </li>
      ))}
    </ol>
  );
};

export default StatusHistory;
